import { ReusableFormFields } from '@/types/common';
import { PROGRAM_SETTING_RULES } from './programSettings';

export const FORM_FIELDS: ReusableFormFields = {
  FIRST_NAME: {
    label: 'First Name',
    rules: { required: true },
  },
  MIDDLE_NAME: {
    label: 'Middle Name',
  },
  LAST_NAME: {
    label: 'Last Name',
    rules: { required: true },
  },
  PHONE: {
    label: 'Phone for Auth (SMS Enabled)',
  },
  CONFIRM_PHONE: {
    label: 'Confirm Phone for Auth',
  },
  BUSINESS_PHONE: {
    label: 'Business Phone',
  },
  EMAIL: {
    label: 'Email',
  },
  CONFIRM_EMAIL: {
    label: 'Confirm Email',
  },
  PASSWORD: {
    label: 'Password',
  },
  CONFIRM_PASSWORD: {
    label: 'Confirm Password',
  },
  SSN: {
    label: 'Social Security Number',
  },
  CONFIRM_SSN: {
    label: 'Confirm Social Security Number',
  },
  SAME_ADDRESS: { label: 'Mailing address is same as current address' },
  DOB: {
    label: 'Date of Birth',
    rules: { required: true },
  },
  LINE1: {
    label: 'Line 1',
    rules: { required: true },
  },
  LINE2: {
    label: 'Line 2',
  },
  CITY: {
    label: 'City',
    rules: { required: true },
  },
  STATE: {
    label: 'State',
    rules: { required: true },
  },
  PROVINCE: {
    label: 'Province/Region Abbreviation',
    rules: {
      maxLength: 3,
      required: true,
    },
  },
  COUNTRY: {
    label: 'Country',
    rules: { required: true },
  },
  ZIP: {
    label: 'Zip',
    rules: { required: true },
  },
  COMPANY: {
    label: 'Company',
    rules: { required: true },
  },
  ADVISORS: {
    label: 'Advisors',
    rules: { required: true },
  },
  MINIMUM_INITIAL_DEPOSIT: {
    label: 'Minimum Initial Deposit',
    rules: {
      min: 0,
      max: PROGRAM_SETTING_RULES.MINIMUM_INITIAL_DEPOSIT,
    },
  },
  MAXIMUM_INITIAL_DEPOSIT: {
    label: 'Maximum Initial Deposit',
    rules: {
      min: 0,
      max: PROGRAM_SETTING_RULES.MAXIMUM_INITIAL_DEPOSIT,
    },
  },
  COMPANY_NAME: {
    label: 'Company Name',
    rules: {
      required: true,
      pattern: {
        regex: /^[a-zA-Z0-9\s]+$/,
        readablePatternName: 'letters and numbers only (no special characters)',
      },
    },
  },
  COMPANY_ALIAS: {
    label: 'Company Alias',
    rules: {
      required: true,
      maxLength: 50,
      pattern: {
        regex: /^[a-z0-9_-]+$/,
        readablePatternName:
          'lowercase letters, numbers, hyphens, and underscores only',
      },
    },
  },
  // Company form specific fields
  ADVISOR_OFFICE_TYPE: {
    label: 'Advisor Office Type',
    rules: { required: true },
  },
  RELATIONSHIP_MANAGER: {
    label: 'Relationship Manager',
    rules: { required: true },
  },
  SAVINGS_INTEREST_RATE: {
    label: 'Savings Interest Rate',
    rules: { required: true },
  },
  MINIMUM_INIT_DEPOSIT: {
    label: 'Minimum Initial Deposit',
    rules: { required: true },
  },
  BRANDING_THEME: {
    label: 'Branding Theme',
    rules: { required: true },
  },
  TEAMMATE_CREATE_PERM: {
    label: 'Create',
  },
  TEAMMATE_UPDATE_PERM: {
    label: 'Update',
  },
  TEAMMATE_DEACTIVATE_REACTIVATE_PERM: {
    label: 'Deactivate/Reactivate',
  },
};
